import $ from "jquery";
import Splide from "@splidejs/splide";
$(function () {
	let text_and_thumbnails = document.querySelectorAll(".text_and_thumbnails");
	if (text_and_thumbnails.length > 0) {
		for (let i = 0; i < text_and_thumbnails.length; i++) {
			let text_and_thumbnailsElement = text_and_thumbnails[i];
			let text_and_thumbnailsDefaultOptions = {
				type: "loop",
				arrows: true,
				pagination: false,
				trimSpace: false,
				perPage: 4,
				perMove: 1,
				gap: "20px",
				breakpoints: {
					1024: {
					  perPage: 2,
				
					},
					767: {
					  perPage: 2,
				
					},
					640: {
					  perPage: 1,
					  padding: '2rem',
					
					},
				},

			};
			let carousel = new Splide(text_and_thumbnailsElement, text_and_thumbnailsDefaultOptions);
			carousel.mount();
		}
	}
});


